<template>
  <div class="componentRoot" style="width: 100vw; overflow: hidden;">
    <v-container fluid class="py-0" :class="{}">
      <v-row>
        <v-col style="position: relative">
          <img alt="Hero Banner Image" src="/images/main/background.jpeg" :style="{
            height: imageHeight
          }" style="
                        width: 100vh; 
                        object-fit: cover; 
                        width: 100%;
                        object-position: center;" />

          <div style="position:absolute; top: 50%; transform: translate(0, -50%);"
            :style="{ 'max-width': maxBannerWidth, 'left': bannerOffset }">
            <p style="color: white" v-html="$t('titleScreens.bannerText')"></p>
            <h1 style="color: white" class="mb-4" v-html="$t('titleScreens.imprint')"></h1>
            <a :href="$getPhoneLink()">
              <v-btn flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
              }}</v-btn>
            </a><br>
            <small style="color:rgb(var(--v-theme-light))" class="ml-4">{{ $t("landing.contactButtonText")
            }}</small>
          </div>
        </v-col>
      </v-row>


      <WaveVue :color="'rgb(var(--v-theme-background))'" :negative="true"
        :style="{ 'margin-top': isMobile ? '-78px' : '-138px' }" :height="isMobile ? 60 : 120"
        style="z-index: 2; position: relative;" />

    </v-container>

    <v-container :fluid="$vuetify.display && $vuetify.display.width < 1920">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="10">
          <article class="legal-doc">
            <h2 class="legal-doc__title">Impressum</h2>

            <h2>Angaben gemäß § 5 DDG</h2>
            <address>
              Rüdiger Keilberg<br />
              Annastraße 9<br />
              34119 Kassel<br />
              Deutschland
            </address>
            <p>Einzelunternehmen (kein Eintrag im Handelsregister).</p>

            <h2>Kontakt</h2>
            <p>
              Telefon: <a :href="phoneHref">{{ phone }}</a><br />
              E-Mail: <a :href="mailto">{{ email }}</a>
            </p>

            <h2>Umsatzsteuer-Identifikationsnummer</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />DE346208291</p>

            <h2>Berufsbezeichnung und berufsrechtliche Angaben</h2>
            <p><strong>Berufsbezeichnung:</strong> Heilpraktiker für Psychotherapie (Erlaubnis nach dem
              Heilpraktikergesetz, beschränkt auf das Gebiet der Psychotherapie), verliehen in der Bundesrepublik
              Deutschland.</p>
            <p><strong>Zuständige Aufsichtsbehörde (Erteilung der Erlaubnis):</strong><br />
              <span class="legal-doc__todo">[Zuständiges Gesundheitsamt mit Anschrift, z.&nbsp;B. Gesundheitsamt Region
                Kassel, Wilhelmshöher Allee 19–21, 34117 Kassel]</span>
            </p>
            <p><strong>Berufsverband:</strong> Mitglied im Verband Freier Psychotherapeuten, Heilpraktiker für
              Psychotherapie und Psychologischer Berater e.&nbsp;V. (VFP). Hinweis: Heilpraktiker sind keiner
              berufsständischen Kammer zugeordnet; die Mitgliedschaft im VFP ist freiwillig.</p>
            <p><strong>Berufsrechtliche Regelungen:</strong></p>
            <ul>
              <li>Gesetz über die berufsmäßige Ausübung der Heilkunde ohne Bestallung (Heilpraktikergesetz – HeilprG)
              </li>
              <li>Erste Durchführungsverordnung zum Heilpraktikergesetz (1. DVO-HeilprG)</li>
              <li>Berufsordnung des VFP</li>
            </ul>
            <p>Die gesetzlichen Regelungen sind einsehbar unter <a href="https://www.gesetze-im-internet.de"
                target="_blank" rel="noopener">www.gesetze-im-internet.de</a>; die Berufsordnung des VFP unter <a
                href="https://www.vfp.de" target="_blank" rel="noopener">www.vfp.de</a>.</p>

            <h2>Berufshaftpflichtversicherung</h2>
            <p>
              <span class="legal-doc__todo">[Name und Anschrift des Versicherers]</span><br />
              Räumlicher Geltungsbereich: <span class="legal-doc__todo">[z.&nbsp;B. Deutschland / Europa]</span>
            </p>

            <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p>Rüdiger Keilberg, Anschrift wie oben.</p>

            <h2>Verbraucherstreitbeilegung</h2>
            <p>Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle bereit.
              Zuständig ist die Allgemeine Verbraucherschlichtungsstelle des Zentrums für Schlichtung e.&nbsp;V.
              (Universalschlichtungsstelle des Bundes), Straßburger Straße 8, 77694 Kehl am Rhein, <a
                href="https://www.verbraucher-schlichter.de" target="_blank"
                rel="noopener">www.verbraucher-schlichter.de</a>.</p>

            <h2>Haftung für Inhalte</h2>
            <p>Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
              überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
              bleiben hiervon unberührt.</p>

            <h2>Haftung für Links</h2>
            <p>Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss
              haben. Für diese fremden Inhalte können wir keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten
              ist stets der jeweilige Anbieter oder Betreiber verantwortlich. Bei Bekanntwerden von Rechtsverletzungen
              werden wir derartige Links umgehend entfernen.</p>

            <h2>Urheberrecht</h2>
            <p>Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
              Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Vervielfältigung, Bearbeitung, Verbreitung
              und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung
              des jeweiligen Urhebers bzw. Erstellers.</p>

            <p class="legal-doc__updated">Stand: {{ lastUpdated }}</p>
          </article>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </div>
</template>


<script>

export default {
  name: "imprint",

  data() {
    return {
      lastUpdated: 'Mai 2026',
      obfuscatedEmail: "kontakt[at]praxis-keilberg[dot]de",
      obfuscatedPhone: "+49-1515-0850942"
    }
  },
  computed: {
    imageHeight() {
            let windowHeight = this.$vuetify.display.height
            let cutoffHeight = 500

            switch (this.$vuetify.display.name) {
                case "xs":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "sm":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "md":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "lg":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xxl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                default:
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
            }
        },
        maxBannerWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "90%";
                case "sm":
                    return "90%";
                case "md":
                    return "90%";
                case "lg":
                    return "80%";
                case "xl":
                    return "80%";
                case "xxl":
                    return "60%"
                default:
                    return "60%"
            }
        },
        bannerOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "10%";
                case "sm":
                    return "10%";
                case "md":
                    return "10%";
                case "lg":
                    return "10%";
                case "xl":
                    return "10%";
                case "xxl":
                    return "15%"
                default:
                    return "15%"
            }
        },
      
    email() {
      return this.obfuscatedEmail
        .replace('[at]', '@')
        .replace('[dot]', '.')
    },
    mailto() {
      return `mailto:${this.email}`
    },

    phone() {
      return this.obfuscatedPhone
        .replaceAll('-', '')
    },

    phoneHref() {
      return `tel:${this.obfuscatedPhone.replaceAll('-', '')}`
    }
  }
}

</script>


<style scoped>
.legal-doc {
  margin-inline: auto;
  padding: clamp(1.25rem, 4vw, 2.5rem);
  font-family: inherit;
  font-size: 1rem;
  line-height: 1.7;
  text-align: left;
  -webkit-text-size-adjust: 100%;
}

.legal-doc__title {
  font-size: clamp(1.6rem, 4vw, 2.1rem);
  line-height: 1.25;
  font-weight: 700;
  margin: 0 0 1.5rem;
  letter-spacing: -0.01em;
}

.legal-doc :is(h2) {
  font-size: 1.2rem;
  font-weight: 700;
  margin: 2.4rem 0 0.75rem;
  padding-bottom: 0.4rem;
}

.legal-doc :is(h3) {
  font-size: 1.02rem;
  font-weight: 700;
  margin: 1.6rem 0 0.5rem;
}

.legal-doc p {
  margin: 0 0 0.9rem;
}

.legal-doc ul {
  margin: 0 0 0.9rem;
  padding-left: 1.4rem;
}

.legal-doc li {
  margin: 0 0 0.45rem;
}

.legal-doc a {
  color: rgb(var(--v-theme-primary));
  text-decoration: underline;
  text-underline-offset: 2px;
  overflow-wrap: anywhere;
}

.legal-doc strong {
  font-weight: 700;
}

.legal-doc address {
  font-style: normal;
  margin: 0 0 0.9rem;
}

.legal-doc__box {
  border: 1px solid rgb(var(--v-theme-primary));
  border-radius: 8px;
  padding: 1rem 1.25rem;
  margin: 0 0 1rem;
}

.legal-doc__box p:last-child {
  margin-bottom: 0;
}

.legal-doc__updated {
  margin-top: 2.5rem;
  opacity: 0.7;
  font-size: 0.9rem;
}

.legal-doc__todo {
  padding: 0 0.25em;
  border-radius: 3px;
  font-style: italic;
}
</style>
